// extracted by mini-css-extract-plugin
export default {"popup":"popup-module__popup___43b4eb"};